import React from 'react';
import { StatCardData } from '../../types';
import './StatCard.css';

interface StatCardProps extends StatCardData {}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  trend,
  trendValue,
  variant = 'blue',
}) => {
  const trendIcon = trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→';
  const trendClass = trend === 'up' ? 'admin-stat-card__trend--up' : trend === 'down' ? 'admin-stat-card__trend--down' : 'admin-stat-card__trend--neutral';

  return (
    <div className={`admin-stat-card admin-stat-card--${variant}`}>
      <div className="admin-stat-card__icon">{icon}</div>
      <div className="admin-stat-card__content">
        <span className="admin-stat-card__label">{label}</span>
        <span className="admin-stat-card__value">{value}</span>
        {trend && trendValue && (
          <span className={`admin-stat-card__trend ${trendClass}`}>
            {trendIcon} {trendValue}
          </span>
        )}
      </div>
    </div>
  );
};
